import { useTranslation } from 'react-i18next';
import { Field, useFormState } from 'react-final-form';
import BusinessIcon from '@mui/icons-material/Business';
import { useNavigate } from 'react-router';

import WithError from '../../../components/with-error/WithError';
import { Input } from '../../../components/common-inputs';
import Icon from '../../../icons/Icon';
import { ICONS } from '../../../icons';
import WithLabel, { LABEL_STYLES } from '../../../components/with-label/WithLabel';
import TooltipButton from '../../../components/tooltip-button/TooltipButton';
import { BUTTON_STYLES } from '../../../components/common-button/CommonButton';
import CommonButtonLink from '../../../components/common-button-link/CommonButtonLink';

import scss from '../AdImagesRequest.module.scss';

function RequestForm({ onSubmit }) {
  const { t } = useTranslation('demoAdImages');
  const { submitting: isLoading } = useFormState();
  const navigate = useNavigate();

  const handleOpenConfirmationForm = () => {
    navigate('/ad/images/demo');
  };

  return (
    <form className={scss.form} onSubmit={onSubmit}>
      <h1 className={scss.title}>{t('requestDemoRecreateImages')}</h1>

      <div className={scss.items}>
        <h4 className={scss.subtitle}>{t('requestAdImagesDescription')}</h4>

        <Field name='email'>
          {({ input, meta }) => (
            <WithLabel variant={LABEL_STYLES.COLUMN} label={t('email')} isRequired isTwoDots isBold>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input
                  formProps={input}
                  autoComplete='email'
                  placeholder={t('contactEmail')}
                  disabled={isLoading}
                  isError={meta.touched && meta.error}
                  LeftIcon={<Icon icon={ICONS.Email} />}
                />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='userName'>
          {({ input, meta }) => (
            <WithLabel variant={LABEL_STYLES.COLUMN} label={t('name')} isRequired isTwoDots isBold>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input
                  formProps={input}
                  autoComplete='name'
                  placeholder={t('fullName')}
                  disabled={isLoading}
                  isError={meta.touched && meta.error}
                  LeftIcon={<Icon icon={ICONS.User} />}
                />
              </WithError>
            </WithLabel>
          )}
        </Field>

        <Field name='companyName'>
          {({ input, meta }) => (
            <WithLabel variant={LABEL_STYLES.COLUMN} label={t('companyName')} isRequired isTwoDots isBold>
              <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
                <Input
                  formProps={input}
                  autoComplete='companyName'
                  placeholder={t('nameOfYourCompany')}
                  disabled={isLoading}
                  isError={meta.touched && meta.error}
                  LeftIcon={<BusinessIcon />}
                />
              </WithError>
            </WithLabel>
          )}
        </Field>
      </div>

      <div className={scss.buttons}>
        <TooltipButton styleColor={BUTTON_STYLES.PRIMARY} type='submit' maxWidth={190} isLoading={isLoading}>
          {t('request')}
        </TooltipButton>

        <CommonButtonLink styleColor={BUTTON_STYLES.SECONDARY} onClick={handleOpenConfirmationForm} type='button'>
          {t('alreadyHaveDemoAccess')}
        </CommonButtonLink>
      </div>
    </form>
  );
}

export default RequestForm;
